import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

/*
	checkoutId ( ID! ) required
	The ID of the checkout.

	lineItems ( [CheckoutLineItemInput!]! ) required
	A list of line item objects to add to the checkout.

		customAttributes ([AttributeInput!])
		Extra information in the form of an array of Key-Value pairs about the line item.

		quantity (Int!) Required
		The quantity of the line item.

		variantId (ID!) Required
		The identifier of the product variant for the line item.
*/

const checkoutLineItemsAdd = (
	`mutation ($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) {
		checkoutLineItemsAdd(checkoutId: $checkoutId, lineItems: $lineItems) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsAdd;
